import React, { useContext, useEffect, useState } from 'react';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { ButtonActionBack, ButtonSelectFarm, ContainerFarmsSelects, DivActionBack, Form, FormControl, H1, H2FarmStore, HeaderTitle, ImgIconBack, InputError, Title, } from '../../assets/styles/GlobalStyles';
import { getMeStore } from '../../services/services';
import { createCookieFarmStore, createCookieUserStore, createCookieCustomerStore, createCookieFarm } from '../../utils/cookies';
import { BgSelectAppWebForm, Logo, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import LogoBoxSelectFarm from '../../assets/images/logo-box-select-farm.svg';
import IconBack from '../../assets/icon/icon-back.svg';
import { InputSearch } from "../../components/Base/Elements/InputSearch";
import { LoadingContext } from '../../components/Loading/Loading.context';
import { translate } from '../../i18n/index';

const SelectFarmStore = ({ history }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [farms, setFarms] = useState([]);
    const [farmsFiltered, setFarmsFiltered] = useState([]);
    const [farmSelected, setFarmSelected] = useState(null);
    const [valueInputSearch, setValueInputSearch] = useState('');
    const { showLoading } = useContext(LoadingContext);

    function redirectToStore() {
        showLoading();
        window.location.href = `${process.env.REACT_APP_STORE_URL}auth/index/authentication`
    }

    useEffect(() => {
        const checkCurrentUserFarm = async () => {
            const userResponse = await getMeStore();
            let dataFarmUser = userResponse?.data?.user?.farmUsers;
            setCurrentUser(userResponse?.data?.user);
            createCookieUserStore(userResponse?.data?.user?.id);
            let farmData = [];

            if (dataFarmUser.length) {
                dataFarmUser
                    .filter(farmUser => farmUser?.buyAllowed)
                    .map((farmUser) => farmData.push({
                        'name': farmUser.farm.name,
                        'id': farmUser.farm.id,
                        'customerId': farmUser.farm.customer.id,
                    }));
            }

            if (farmData.length > 0) {
                setFarms(farmData);
            } else {
                if (userResponse.data.user.customer) {
                    createCookieCustomerStore(userResponse.data.user.customer.id);
                }
                window.location.href = `${process.env.REACT_APP_STORE_URL}auth/index/authentication`
            }
        };
        checkCurrentUserFarm();
    }, []);

    function handleChange(e) {
        setValueInputSearch(e.target.value);
        setFarmsFiltered(farms.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase())));
    }

    function handleClickSelectFarm(value) {
        setFarmSelected(value);
    }

    if (!farms.length) {
        return <div />
    }

    return (
        <>
            <DivActionBack>
                <ButtonActionBack onClick={() => history.goBack()} type="button">
                    <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                </ButtonActionBack>
            </DivActionBack>
            <div>
                <HeaderTitle>
                    <H1>
                        {translate('accessFarmWelcome')} {currentUser ? currentUser.name : ''}
                    </H1>
                    <H2FarmStore>
                        {translate('selectFarmConfirmation')}
                    </H2FarmStore>
                </HeaderTitle>
            </div>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                    <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
                </LogoContainer>
            </div>
            <Base width={430} isAppWeb={false} isStore={true} isImilk={false}  >
                <ContentContainer>
                    {farms && (
                        <Formik
                            enableReinitialize
                            initialValues={{
                                farm: '',
                            }}
                            onSubmit={async (values, actions) => {
                                // let farmParam = '';
                                if (farmSelected) {
                                    // farmParam = `&farm=${farmSelected.id}`;
                                    createCookieFarm(farmSelected);
                                    createCookieFarmStore(farmSelected.id);
                                    createCookieCustomerStore(farmSelected.customerId);
                                    redirectToStore();
                                }
                            }}>
                            {({ isSubmitting }) => (
                                <Form>
                                    <Title>
                                        <H1>
                                            <LogoContainer
                                                href='#'
                                                style={{ alignSelf: 'center' }}
                                                rel="noopener noreferrer"
                                                target="_self">
                                                <Logo height="100px" src={LogoBoxSelectFarm} alt="Logo do site" title="OnFarm" />
                                            </LogoContainer>
                                        </H1>
                                    </Title>

                                    <FormControl>
                                        <Field
                                            name="search"
                                            key="search-farm"
                                            placeholder={translate('inputSearchFarm')}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={valueInputSearch}
                                            component={InputSearch}
                                        />
                                        <ErrorMessage name="search" component={InputError} />
                                    </FormControl>
                                    <ContainerFarmsSelects>
                                        {!farmsFiltered.length ?
                                            <>
                                                {farms.map((farm, index) => (
                                                    <FormControl key={farm.id}>
                                                        <ButtonSelectFarm onClick={() => handleClickSelectFarm(farm)} key={index + '-' + farm.name} type="submit">
                                                            {farm.name}
                                                        </ButtonSelectFarm>
                                                    </FormControl>
                                                ))}
                                            </>
                                            :
                                            <>
                                                {farmsFiltered.map((farm, index) => (
                                                    <FormControl key={farm.id + '-filtered'}>
                                                        <ButtonSelectFarm onClick={() => handleClickSelectFarm(farm)} key={index + '-' + farm.name + '-filtered'} type="submit">
                                                            {farm.name}
                                                        </ButtonSelectFarm>
                                                    </FormControl>
                                                ))}
                                            </>
                                        }
                                    </ContainerFarmsSelects>
                                    <FormControl>
                                        <ButtonSelectFarm name="farm" type="submit">
                                            {translate('noPoints')}
                                        </ButtonSelectFarm>
                                    </FormControl>
                                </Form>
                            )}
                        </Formik>
                    )}
                </ContentContainer>
            </Base>
        </>
    );
};

export default SelectFarmStore;
